import React from 'react';
import {
  DtpFileUpload,
} from 'dtp-react-components';

const FileUpload = props => (
  <DtpFileUpload {...props} />
);

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/FileUpload.jsx